import { render, staticRenderFns } from "./Staff.vue?vue&type=template&id=5df51ec7&scoped=true"
import script from "./Staff.vue?vue&type=script&lang=js"
export * from "./Staff.vue?vue&type=script&lang=js"
import style0 from "./Staff.vue?vue&type=style&index=0&id=5df51ec7&prod&lang=scss&scoped=true"
import style1 from "./Staff.vue?vue&type=style&index=1&id=5df51ec7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df51ec7",
  null
  
)

export default component.exports